<template>
  <ValidationObserver ref="sexualOrientation">
    <div>
      <h2 class="mb-5">
        Which of the following best describes your sexual orientation?
      </h2>
    </div>
    <div v-if="isFetchingSexualOrientations">
      <v-skeleton-loader type="list-item-three-line" />
    </div>
    <ValidationProvider
      v-slot="{ errors }"
      name="sexualOrientation"
      rules="required"
      v-else
    >
      <RadioButton
        :errorMessages="showValidationErrors ? errors : ''"
        v-model="sexualOrientation"
        @select="val => (sexualOrientation = val)"
        :options="options"
        mixed
        :selectedValue="sexualOrientation"
      />
    </ValidationProvider>

    <div class="d-flex justify-end">
      <PrimaryButton @click.native="nextStep" :loading="isLoading">
        Continue
      </PrimaryButton>
    </div>
  </ValidationObserver>
</template>

<script>
import PrimaryButton from "@/components/common/Button/PrimaryButton";
import { DATA_NAMESPACE } from "@/store/modules/data";
import { createNamespacedHelpers } from "vuex";
import { FETCH_SEXUAL_ORIENTATIONS } from "@/store/modules/data/actions";
import {
  GET_SEXUAL_ORIENTATIONS,
  GET_IS_FETCHING_SEXUAL_ORIENTATIONS
} from "@/store/modules/data/getters";
import { map } from "lodash";
import RadioButton from "@/components/common/RadioButton";
import {
  includePreferNotSayOption,
  getFormattedValue
} from "@/views/profile/QuestionsAndAnswers/steps/Diversity/utils";
import { ValidationProvider, ValidationObserver } from "vee-validate";

const { mapGetters, mapActions } = createNamespacedHelpers(DATA_NAMESPACE);

export default {
  name: "SexualOrientation",
  components: {
    PrimaryButton,
    RadioButton,
    ValidationProvider,
    ValidationObserver
  },
  props: {
    isLoading: Boolean,
    userDiversityTraits: Object
  },
  created() {
    this.fetchSexualOrientations();
  },
  data() {
    return {
      sexualOrientation: this.userDiversityTraits.sexualOrientation,
      showValidationErrors: false
    };
  },
  computed: {
    options() {
      const fetchedOptions = map(this.sexualOrientations, ({ name }) => ({
        label: name,
        value: name
      }));
      return includePreferNotSayOption(fetchedOptions);
    },
    ...mapGetters({
      sexualOrientations: GET_SEXUAL_ORIENTATIONS,
      isFetchingSexualOrientations: GET_IS_FETCHING_SEXUAL_ORIENTATIONS
    })
  },
  methods: {
    ...mapActions({
      fetchSexualOrientations: FETCH_SEXUAL_ORIENTATIONS
    }),
    async nextStep() {
      this.showValidationErrors = true;
      const isValid = await this.$refs.sexualOrientation.validate();
      if (isValid) {
        this.$emit("nextStep", {
          data: {
            sexualOrientation: getFormattedValue(this.sexualOrientation)
          },
          dataType: "divirsityTraits"
        });
      }
    }
  }
};
</script>

<style lang="scss"></style>
